import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

interface HideSidebarContextProps {
  hideSidebar: boolean;
  isReady: boolean;
}

export const HideSidebarContext = React.createContext<HideSidebarContextProps>({
  hideSidebar: false,
  isReady: false,
});

export const HideSidebarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [searchParams] = useSearchParams();
  const [hideSidebar, setHideSidebar] = React.useState<boolean>(false);
  const [isReady, setIsReady] = React.useState<boolean>(false);

  useEffect(() => {
    if (searchParams.has("hidesidebar")) {
      sessionStorage.setItem(
        "hidesidebar",
        searchParams.get("hidesidebar") === "true" ? "true" : "false"
      );
      setHideSidebar(searchParams.get("hidesidebar") === "true");
    }

    setIsReady(true);

    window.addEventListener("storage", (event) => {
      setIsReady(false);

      if (event.key === "hidesidebar") {
        setHideSidebar(event.newValue === "true");
      }

      setIsReady(true);
    });
  }, [searchParams]);

  return (
    <HideSidebarContext.Provider value={{ hideSidebar, isReady }}>
      {isReady ? children : null}
    </HideSidebarContext.Provider>
  );
};
